/**
 * What must never leave the browser in an analytics beacon.
 *
 * Pure, in the same spirit as previewOutcome and loginGateOutcome: the rule is
 * security-sensitive, so it should be readable and assertable in one file
 * rather than inlined in a JSX prop nobody tests.
 */

/**
 * Drop the URL fragment.
 *
 * The outreach convert token lives in the hash (`/r#<token>`) specifically so
 * it never reaches a server log — and it is the WHOLE credential: whoever holds
 * it can complete the conversion. Vercel Analytics attaches the page URL to
 * every event, so without this the token would be carried off-origin on each
 * one, undoing the reason it is in the hash at all. Nothing this app measures
 * needs the fragment.
 */
export function scrubUrlFragment(url: string): string {
  return url.split("#")[0] ?? "";
}
